export enum ProductTourStatusType {
  Completed = 'completed',
  Skipped = 'skipped',
  Dismissed = 'dismissed',
}
